import { forwardRef } from "react";
import { IoClose } from "react-icons/io5";

import { clx } from "~/shared/clx";

import * as styles from "./styles.css";

import type { Notification, Notified } from "../types";
import type { ReactNode, CSSProperties } from "react";

type Props = {
  type: Notification["type"];
  children?: ReactNode;
  style?: CSSProperties;
  closable?: boolean;

  onClose?: () => void;
};

const Message = forwardRef<HTMLDivElement, Props>((props, ref) => {
  return (
    <div className={clx(styles.baseMessage, getMessageClassName(props.type))} style={props.style} ref={ref}>
      {props.children}
      {props.closable ? (
        <button className={styles.closeButton} aria-label="close notify" onClick={props.onClose}>
          <IoClose />
        </button>
      ) : null}
    </div>
  );
});

/**
 * @package
 */
export default Message;

const getMessageClassName = (type: Notified["type"]) => {
  switch (type) {
    case "info":
      return undefined;
    case "success":
      return styles.successMessage;
    case "warning":
      return styles.warningMessage;
    case "error":
      return styles.errorMessage;
  }
};
